import React from 'react';
import PropTypes from 'prop-types';

const FormFieldIcon = ({ children }) => (
  <span className="inline-flex shrink-0 -translate-y-[3px]">{children}</span>
);

FormFieldIcon.propTypes = {
  children: PropTypes.node,
};

export default FormFieldIcon;
